import { combineReducers } from "redux";
import themeSlice from "../slices/theme/themeSlice";
const rootReducer = combineReducers({
  theme: themeSlice,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
